import Script from 'next/script'

import { GTAG_QUEUE_SNIPPET } from '../lib/gtag'

const ADS_TAG = process.env.NEXT_PUBLIC_GOOGLE_ADS_TAG || process.env.VITE_GOOGLE_ADS_TAG
const CONVERSION_LABEL =
  process.env.NEXT_PUBLIC_GOOGLE_ADS_PIXEL_DESKTOP_APP_INSTALLED ||
  process.env.VITE_GOOGLE_ADS_PIXEL_DESKTOP_APP_INSTALLED

// Sends on every visit by design — GoogleAds does the deduplication.
export function DesktopInstallConversion() {
  if (!ADS_TAG || !CONVERSION_LABEL) {
    return null
  }

  return (
    <Script id="desktop-install-conversion" strategy="afterInteractive">
      {`
        ${GTAG_QUEUE_SNIPPET}
        window.gtag('config', '${ADS_TAG}');
        window.gtag('event', 'conversion', { send_to: '${ADS_TAG}/${CONVERSION_LABEL}' });
      `}
    </Script>
  )
}
